export function getCurrentUser() {
  const user = sessionStorage.getItem('user');
  if (!user) {
    return {};
  }
  try {
    return JSON.parse(user) || {};
  } catch (error) {
    return {};
  }
}

export function getApiToken() {
  return getCurrentUser().api_token || '';
}

export function getApiTokenHeaders() {
  const token = getApiToken();
  return token ? { 'api-token': token } : {};
}
